import '../ViewNFT.css'
import { useEffect, useState } from "react"
import Loading from "../../../components/Loading";

function NFTTweet(){
    return (
        <div>
            <p>Twitter data extraction to be completed</p>
        </div>
    )
}

export default NFTTweet;